import type { ComparableLocale } from './types/ComparableLocale'
import { exists } from './utils/exists'

export function pickUserLocale(
  supportedLocales: string[],
  fallbackLocale: string
): string {
  // Browser locales are ordered by user preference
  const browserLocales = window.navigator.languages ?? [
    window.navigator.language,
  ]

  const locale = pickMatchingLocale(
    browserLocales.map(parseLocale),
    supportedLocales.map(parseLocale)
  )

  if (locale === undefined) {
    return fallbackLocale
  }

  return localeToString(locale)
}

/*
  Keeps the ordering of browserLocales
  Returns values from supportedLocales, as browserLocales doesn't always contain regionCode
*/
function pickMatchingLocale(
  browserLocales: ComparableLocale[],
  supportedLocales: ComparableLocale[]
): ComparableLocale | undefined {
  for (const left of browserLocales) {
    for (const right of supportedLocales) {
      if (isExactlyEqual(left, right)) return right
    }
    for (const right of supportedLocales) {
      if (isPartiallyEqual(left, right)) return right
    }
  }
}

function isExactlyEqual(
  left: ComparableLocale,
  right: ComparableLocale
): boolean {
  return (
    left.languageCode === right.languageCode &&
    left.regionCode === right.regionCode
  )
}

function isPartiallyEqual(
  left: ComparableLocale,
  right: ComparableLocale
): boolean {
  return left.languageCode === right.languageCode
}

function parseLocale(localeString: string): ComparableLocale {
  const [languageCode, regionCode] = localeString.split(/-|_/)

  return {
    languageCode: languageCode.toLowerCase(),
    regionCode: regionCode?.toUpperCase(),
  }
}

function localeToString(locale: ComparableLocale): string {
  return [locale.languageCode, locale.regionCode].filter(exists).join('-')
}

// function forceLocaleStyle(localeString: string): string {
//   return localeToString(parseLocale(localeString))
// }
